import React from "react";
import { motion } from "framer-motion";

const TechBadge = ({ tech, size = "sm", variant = "default" }) => {
  const getTechColor = (technology) => {
    const techColors = {
      // Frontend
      React: "#61DAFB",
      "Vue.js": "#4FC08D",
      Angular: "#DD0031",
      JavaScript: "#F7DF1E",
      TypeScript: "#3178C6",
      HTML: "#E34F26",
      CSS: "#1572B6",
      Sass: "#CC6699",
      Tailwind: "#06B6D4",
      Bootstrap: "#7952B3",
      "Three.js": "#000000",
      "Next.js": "#000000",
      Gatsby: "#663399",
      Svelte: "#FF3E00",

      // Backend
      Python: "#3776AB",
      "Node.js": "#339933",
      Django: "#092E20",
      FastAPI: "#009688",
      Flask: "#000000",
      Express: "#000000",
      PHP: "#777BB4",
      Laravel: "#FF2D20",
      Ruby: "#CC342D",
      Go: "#00ADD8",
      Java: "#ED8B00",
      "C#": "#239120",

      // Databases
      MongoDB: "#47A248",
      PostgreSQL: "#336791",
      MySQL: "#4479A1",
      Redis: "#DC382D",
      SQLite: "#003B57",
      Firebase: "#FFCA28",

      // DevOps & Tools
      Docker: "#2496ED",
      Kubernetes: "#326CE5",
      AWS: "#FF9900",
      Azure: "#0078D4",
      GCP: "#4285F4",
      Nginx: "#009639",
      Apache: "#D22128",
      Git: "#F05032",
      GitHub: "#181717",
      GitLab: "#FCA326",

      // Design
      Figma: "#F24E1E",
      "Adobe XD": "#FF61F6",
      Sketch: "#F7B500",
      Photoshop: "#31A8FF",
      Illustrator: "#FF9A00",
      "After Effects": "#9999FF",

      // Mobile
      "React Native": "#61DAFB",
      Flutter: "#02569B",
      Swift: "#FA7343",
      Kotlin: "#7F52FF",

      // AI/ML
      TensorFlow: "#FF6F00",
      PyTorch: "#EE4C2C",
      OpenAI: "#412991",
      "Hugging Face": "#FFD21E",

      // Default
      default: "#6B7280",
    };

    return techColors[technology] || techColors.default;
  };

  const sizeClasses = {
    xs: "text-xs px-2 py-1",
    sm: "text-xs px-3 py-1",
    md: "text-sm px-3 py-1.5",
    lg: "text-sm px-4 py-2",
  };

  const variantClasses = {
    default: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
    colored: "text-white",
    outline: "border-2 bg-transparent",
    solid: "text-white",
  };

  const techColor = getTechColor(tech);

  const getVariantStyles = () => {
    switch (variant) {
      case "colored":
        return {
          backgroundColor: techColor,
          color: "white",
        };
      case "outline":
        return {
          borderColor: techColor,
          color: techColor,
          backgroundColor: "transparent",
        };
      case "solid":
        return {
          backgroundColor: techColor,
          color: "white",
        };
      default:
        return {};
    }
  };

  return (
    <motion.span
      className={`
        inline-flex items-center font-medium rounded-full transition-all duration-200
        ${sizeClasses[size]}
        ${variantClasses[variant]}
      `}
      style={getVariantStyles()}
      whileHover={{
        scale: 1.05,
        boxShadow: `0 4px 12px ${techColor}40`,
      }}
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
    >
      {tech}
    </motion.span>
  );
};

export default TechBadge;
